import useInstallBackend from "../hooks/useInstallBackend";

export default function ShopifyInstall({ onComplete }) {
  useInstallBackend(onComplete);
  return null;
}